import {
  createBrandAndPriceFilters,
  isPriceInSelectedRanges,
  keepSelectedFilterOptions,
  roundUpToStep,
} from '../../common/utils/productListUtilsCoCo.js';
import { getDeviceBrand, getOfferPriceEuros } from './productGridUtilsCoCo.js';
import type { Filters } from './ProductGridFilterCoCo.js';
import type { DeviceProductOffer } from './productGridUtilsCoCo.js';

export {
  MAX_DEFAULT_VISIBLE_OPTIONS,
  createPriceFilterLabel,
  createRangeOptions,
  getFilterKeys,
  getRange,
  getSelectedOptionsStillAvailable,
  gridFilter,
  hasActiveFilters,
} from '../../common/utils/productListUtilsCoCo.js';

export const roundToHundredEuros = (price: number) => roundUpToStep(price, 100);

export const getFilterRange = (offer: DeviceProductOffer, selections: string[]) =>
  isPriceInSelectedRanges(getOfferPriceEuros(offer), selections);

export const createFilters = (offers: DeviceProductOffer[]): Filters =>
  createBrandAndPriceFilters(offers, {
    getBrand: getDeviceBrand,
    getPriceEuros: getOfferPriceEuros,
    priceRangeSize: 300,
    priceRoundingStep: 100,
  });

export const rebuildFilters = (offers: DeviceProductOffer[], previous: Filters): Filters =>
  keepSelectedFilterOptions(previous, createFilters(offers));
